import { Navigate, Outlet } from 'react-router';
import { isProd } from '@/_config/env';

interface StageOnlyOutletProps {
  redirectTo?: string;
  replace?: boolean;
}

/**
 * Renders a component only in staging or development environments, otherwise redirects to a specified route.
 * @param redirectTo - The route to redirect to if not in production environment.
 * @param replace - Whether to replace the current entry in the history stack with the new one.
 * @returns A `Navigate` component if in production environment, otherwise an `Outlet` component.
 */
function StageOnlyOutlet({
  redirectTo = '/',
  replace = true,
}: StageOnlyOutletProps) {
  if (isProd) {
    return <Navigate to={redirectTo} replace={replace} />;
  }

  return <Outlet />;
}

export { StageOnlyOutlet };
